define('lq/design/responsiveDesign',[
    'underscore',
    'lq/responsive',
    'lq/drop'
], function (_, responsive, Drop) {
    'use strict';

    var addLayoutReference = function (data, layoutInfo) {
        data.layoutId = layoutInfo.id;
        data.layoutType = layoutInfo.layoutType;
    };

    var getLayoutData = function (dropData, layoutInfo) {
        return _.findWhere(dropData.layouts, { layoutId: layoutInfo.id });
    };

    var createLayoutData = function (dropData, layoutInfo) {
        var dropLayoutData = {
            size: {},
            position: {}
        };
        addLayoutReference(dropLayoutData, layoutInfo);
        dropData.layouts = dropData.layouts || [];
        dropData.layouts.push(dropLayoutData);
        return dropLayoutData;
    };

    var initLayoutWithCurrentIfEmpty = function (drop, layoutInfo) {
        var dropLayout = getLayoutData(drop.data, layoutInfo);
        if (!dropLayout) {
            dropLayout = createLayoutData(drop.data, layoutInfo);
            responsive.copyDropLayout(drop.data.type, drop.data, dropLayout);
        }
    };

    var initLayoutWithCurrentIfEmptyRecursive = function (drop, pageLayoutInfo) {
        initLayoutWithCurrentIfEmpty(drop, pageLayoutInfo);

        _.each(drop.childDrops, function (childDrop) {
            initLayoutWithCurrentIfEmptyRecursive(childDrop, pageLayoutInfo);
        });
    };

    var initDefaultLayoutIfEmptyRecursive = function (drop) {
        initLayoutWithCurrentIfEmptyRecursive(drop, Drop.rootDrop.defaultLayout);
    };

    var getOrCreateLayoutData = function (dropData, currentLayoutInfo) {
        var dropLayoutData = getLayoutData(dropData, currentLayoutInfo);
        return dropLayoutData || createLayoutData(dropData, currentLayoutInfo);
    };

    var updateDropLayout = function (dropData, decoratorFunc, isLocal) {
        var currentLayoutInfo = this.getCurrentLayout();
        // on the server the default layout is stored in the root of the drop data, on the client the currently selected one
        if (isLocal || createLayoutData.isDefault || !currentLayoutInfo)
            decoratorFunc(dropData);
        if (currentLayoutInfo) {
            var dropLayout = getOrCreateLayoutData(dropData, currentLayoutInfo);
            decoratorFunc(dropLayout);
        }
    };

    var updateServerDropLayout = function (dropData, decoratorFunc) {
        this.updateDropLayout(dropData, decoratorFunc, false);
    };

    var updateLocalDropLayout = function (dropData, decoratorFunc) {
        this.updateDropLayout(dropData, decoratorFunc, true);
    };

    var isAnAppliedLayout = function(layout) {
        return !Drop.rootDrop.data.appliedLayouts ||
            Drop.rootDrop.data.appliedLayouts.length === 0 ||
            _.indexOf(Drop.rootDrop.data.appliedLayouts, layout.id) !== -1;
    };

    var getCurrentLayout = function () {
        var currentLayoutId = this.getLayoutIdFromUri();
        var selectedLayout = currentLayoutId && _.findWhere(Drop.rootDrop.allLayouts, { id: currentLayoutId });
        if (selectedLayout && isAnAppliedLayout(selectedLayout))
            return selectedLayout;

        var initialLayoutId = Drop.rootDrop.initialLayoutId;
        selectedLayout = initialLayoutId && _.findWhere(Drop.rootDrop.allLayouts, { id: initialLayoutId });
        if (selectedLayout && isAnAppliedLayout(selectedLayout))
            return selectedLayout;
        
        if (Drop.rootDrop.data.appliedLayouts && Drop.rootDrop.data.appliedLayouts.length > 0 && _.indexOf(Drop.rootDrop.data.appliedLayouts, Drop.rootDrop.defaultLayout.id) === -1) {
            return _.findWhere(Drop.rootDrop.allLayouts, { id: Drop.rootDrop.data.appliedLayouts[0] });
        }

        return Drop.rootDrop.defaultLayout;
    };

    var copyDataOfCurrentLayoutToAllMissingLayouts = function (dropType, dropData, sourceLayoutData) {
        _.each(Drop.rootDrop.allLayouts, function (aLayout) {
            if (aLayout.id === sourceLayoutData.layoutId) return;

            var dataOfTheLayout = _.findWhere(dropData.layouts, { layoutId: aLayout.id });

            if (dataOfTheLayout) return;

            dataOfTheLayout = $.extend(true, {}, sourceLayoutData);
            dataOfTheLayout.layoutId = aLayout.id;
            dropData.layouts.push(dataOfTheLayout);
        });
    };

    return _.extend({}, responsive, {
        addLayoutReference: addLayoutReference,
        getLayoutData: getLayoutData,
        createLayoutData: createLayoutData,
        getOrCreateLayoutData: getOrCreateLayoutData,
        updateDropLayout: updateDropLayout,
        updateLocalDropLayout: updateLocalDropLayout,
        updateServerDropLayout: updateServerDropLayout,
        initDefaultLayoutIfEmptyRecursive: initDefaultLayoutIfEmptyRecursive,
        getCurrentLayout: getCurrentLayout,
        copyDataOfCurrentLayoutToAllMissingLayouts: copyDataOfCurrentLayoutToAllMissingLayouts
    });
});

